import CryptoJS from 'crypto-js';

interface ICardProps {
  cardNumber: string;
  month: string;
  year: string;
  codSec: string;
}

const encryptCard = ({
  cardNumber,
  codSec,
  month,
  year
}: ICardProps): string => {
  const publicKey = process.env.REACT_APP_COMUNIX_PK;
  if (!publicKey) {
    return 'Chave pública não definida.';
  }
  const dataToEncrypt = `${cardNumber.replace(/\D/g, '')};${month};${year};${codSec}`;
  return CryptoJS.AES.encrypt(dataToEncrypt, publicKey).toString();
};

export { encryptCard };
